export default __webpack_public_path__ + "d257a7ab4a43f5e3b2b537bc5b1f690b.png";